<div class="bg-theme-orange rounded-xl w-full h-full">
  <div class="content absolute left-0 top-0 w-[100%] hidden p-5">
    <div class="absolute left-0 sm-home:left-55 top-0 w-38 2xs:w-64 md:left-75 lg:left-125 2xl:left-175
        h-29 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-orange/home-why-pink-cloud.svg)] bg-right-top bg-contain bg-no-repeat">
    </div>
    <div class="absolute top-75 sm-home:top-78 2xl:top-70 left-0 w-[600px] lg:-ml-0 lg:w-[700px] 2xl:w-[824px]
    h-30 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-orange/home-why-purple-line.svg)] bg-right-bottom bg-contain bg-no-repeat">
    </div>
    <div class="absolute sm-home:ml-[24px] left-4 sm-home:left-75 md:left-90 lg:left-142 2xl:left-158
        top-78 sm-home:top-58 2xl:top-58
        w-48 sm-home:w-35 2xl:w-70
        h-32 sm-home:h-52 bg-center sm-home:bg-center 2xl:bg-top rounded-xl bg-cover bg-no-repeat
        bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/subscription/event-24.webp)]">
    </div>
    <div class="absolute left-4 sm-home:left-10 top-7 2xs:top-12 w-55 xs-home:w-[270px] 2xs:w-90 lg:w-110 2xl:w-140 h-25">
      <h3 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold">7 à 10 vraies rencontres<br/>pour maximiser tes chances</h3>
      <p class="font-theme-source text-sm xs-home:text-base lg:text-base text-theme-black mt-1 xs-home:mt-3 sm-home:mt-5 lg:mt-3 mr-7 xs:mr-2 2xs:mr-10 sm-home:mr-32 lg:mr-12">
        Laisse-toi transporter par des vraies rencontres sécurisées dont 75% garanties dans la tranche d’âge sélectionnée.
        Un planning de rendez-vous sérieux à Nantes composé selon tes critères pour un bon contact ou peut-être une nuit...
      </p>
    </div>
  </div>
</div>

